import type { IconSvgObject } from './types';

const CornerDownRightIcon: IconSvgObject = [
  ["path", { d: "M19 15H12C8.22876 15 6.34315 15 5.17157 13.8284C4 12.6569 4 10.7712 4 7V4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 20C15 20 20 16.3176 20 15C20 13.6824 15 10 15 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CornerDownRightIcon;
